import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ClientsService } from '@app/shared/services/clients.service';
import { OrderService } from '@app/shared/services/order.service';
import { MatMixService } from '@app/shared/services/mat-mix.service'; 
import { JssService } from '@app/shared/services/jss.service';
import { MATERIAL_OPTIONS } from './material-options';
import { Router } from '@angular/router';


@Component({
  selector: 'app-add-prod',
  templateUrl: './add-prod.component.html',
  styleUrls: ['./add-prod.component.css']
})
export class AddProdComponent implements OnInit {
  addMaterialForm: FormGroup;
  clientList: any[] = [];
  jobList: any[] = [];
  orderList: any[] = [];
  selectedMaterial: string = '';
  selectedProcess: string = '';
  materialOptions = MATERIAL_OPTIONS;
  ClientName: string = ''; // Property to hold the selected client's name
  JobName: string = ''; // Property to hold the selected job's name
  materialMixEntries: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  selectedMaterials: string[] = [];
  orderId: string = '';

  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private clientsService: ClientsService,
    private matMixService: MatMixService,
    private cdr: ChangeDetectorRef,
    private jss: JssService,
    private router: Router
  ) {
    this.addMaterialForm = this.fb.group({
      clientName: [''], // Add Validators.required for required fields
      jobName: [''], // Add Validators.required for required fields
      process: [''],
      material: [''],
      rollNo: [''],
      weight: [''],
      return: [''],
      outputKgs: [''],
      wasteKgs: [''],
      flag: [''],
    });
  } 

  ngOnInit(): void {
    // Fetch data from the services
    this.clientsService.getClientList().subscribe(
      (clients: any[]) => {
        this.clientList = clients;
        this.cdr.detectChanges(); // Manually trigger change detection

      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );
  
    this.jss.getJssList().subscribe((orders: any[]) => {
      // Filter orders to include only reconfirmed ones
      this.orderList = orders.filter(order => order.status === 'CreateJss');
    });
  
    // Listen for changes on the 'clientName' form control
    this.addMaterialForm.get('clientName').valueChanges.subscribe((selectedClient) => {
      // Update the ClientName property with the selected client's name
      this.ClientName = selectedClient;
      // Update jobList based on the selected client
      this.updateJobList(selectedClient);
    });
  
    // Listen for changes on the 'jobName' form control
    this.addMaterialForm.get('jobName').valueChanges.subscribe((selectedJob) => {
      // Update the JobName property with the selected job's name
      this.JobName = selectedJob;
      console.log(this.JobName);
      // Fetch JSS data for the selected client and job
      this.fetchJssData(selectedJob);
    });

    // this.fetchAllMaterialMix();
  }

  updateJobList(selectedClient: string): void {
    if (selectedClient) {
      // Update jobList based on the selected client
      this.jobList = this.orderList
        .filter(order => order.clientName.toLowerCase() === selectedClient.toLowerCase())
        .map(order => order.jobName);
    } else {
      this.jobList = [];
    }
  
    // Reset the jobName selection when the client changes
    this.addMaterialForm.patchValue({
      jobName: null,
    });
  }
  
  
  fetchJssData(selectedJob: string): void {
    const selectedOrder = this.orderList.find(order => order.jobName.toLowerCase() === selectedJob.toLowerCase());
    if (selectedOrder) {
      // Extract the desired fields and store the selected values in the array
      this.selectedMaterials = [];
  
      if (selectedOrder.printingMat.selectedPrintingMat) {
        this.selectedMaterials.push(selectedOrder.printingMat.selectedPrintingMat);
      }
      if (selectedOrder.laminatMat1.selectedLaminatMat1) {
        this.selectedMaterials.push(selectedOrder.laminatMat1.selectedLaminatMat1);
      }
      if (selectedOrder.laminatMat2.selectedLaminatMat2) {
        this.selectedMaterials.push(selectedOrder.laminatMat2.selectedLaminatMat2);
      }
      if (selectedOrder.laminatMat3.selectedLaminatMat3) {
        this.selectedMaterials.push(selectedOrder.laminatMat3.selectedLaminatMat3);
      }
  
      // Now you have access to the selected values in one array
      console.log('Selected Materials:', this.selectedMaterials);
    } else {
      console.error('No matching order found for the selected job name.');
      // Reset the selected materials array
      this.selectedMaterials = [];
    }
  }
  
  
  processSelected: boolean = false;
  materialSelected: boolean = false;

  onProcessSelect(selectedProcess: string): void {
    this.processSelected = !!selectedProcess;
    this.materialSelected = !this.processSelected;
    // Reset the selected material when a process is selected
    this.selectedMaterial = '';
  }
  
  onMaterialSelect(selectedMaterial: string): void {
    this.materialSelected = !!selectedMaterial;
    this.processSelected = !this.materialSelected;
    // Reset the selected process when a material is selected
    this.selectedProcess = '';
  }
  

  
  addMaterial(): void {
    // Create a new material mixing object with form values
    const newMaterialMixEntry = {
      clientName: this.addMaterialForm.value.clientName,
      jobName: this.addMaterialForm.value.jobName,
      matArray: [{
        materialMix: this.addMaterialForm.value.process || this.addMaterialForm.value.material,
        rollNo: this.addMaterialForm.value.rollNo,
        weight: this.addMaterialForm.value.weight,
        return: this.addMaterialForm.value.return,
        outputKgs: this.addMaterialForm.value.outputKgs,
        wasteKgs: this.addMaterialForm.value.wasteKgs,
        flag: this.addMaterialForm.value.flag,
      }]
    };
  
    console.log(newMaterialMixEntry);
  
    // Update the local array to include the new material mixing entry
    this.materialMixEntries.push(newMaterialMixEntry);
    
    console.log(this.materialMixEntries);
    this.removeSelectedProcessFromDropdown();
  }
  
  
  saveAndContinue(): void {
    if (this.materialMixEntries.length === 0 || !this.ClientName || !this.JobName) {
      console.error('No material mix entries to save or missing client name/job name.');
      return;
    }
  
    const orderId = this.getOrderId(this.ClientName, this.JobName);
  
    const matArray = this.materialMixEntries.map(entry => ({
      materialMix: entry.matArray[0].materialMix,
      rollNo: entry.matArray[0].rollNo,
      weight: entry.matArray[0].weight,
      return: entry.matArray[0].return,
      outputKgs: entry.matArray[0].return,
      wasteKgs: entry.matArray[0].wasteKgs,
      flag: entry.matArray[0].flag
    }));
  
    const dataToSave = {
      orderId: orderId,
      clientName: this.ClientName,
      jobName: this.JobName,
      matArray: matArray
    };
  
    this.matMixService.createMatMix(dataToSave).subscribe(
      (response) => {
        console.log('Material mix entries saved successfully:', response);
        this.materialMixEntries = [];
        // Redirect to the desired route after saving
        this.router.navigate(['/matAllot'], { queryParams: { orderId: orderId } });
      },
      (error) => {
        console.error('Error saving material mix entries:', error);
      }
    );
  }
  
  

  removeSelectedProcessFromDropdown(): void {
    const selectedProcessIndex = this.selectedMaterials.indexOf(this.addMaterialForm.value.process);
    if (selectedProcessIndex !== -1) {
      this.selectedMaterials.splice(selectedProcessIndex, 1);
    }
  }

  
  
 
  deleteMaterialMix(index: number): void {
    if (confirm("Are you sure you want to delete this material mix entry?")) {
      if (index >= 0 && index < this.materialMixEntries.length) {
        const deletedEntry = this.materialMixEntries.splice(index, 1)[0];
        const deletedProcess = deletedEntry.matArray[0].materialMix; // Assuming matArray is an array with a single object
  
        // Re-add the deleted process to the selected materials if it's not already included
        if (deletedProcess && !this.selectedMaterials.includes(deletedProcess)) {
          this.selectedMaterials.push(deletedProcess);
          this.selectedMaterials.sort();
        }
  
        // Reset the process dropdown value if it was equal to the deleted process
        if (this.addMaterialForm.value.process === deletedProcess) {
          this.addMaterialForm.get('process').setValue('');
        }
  
        // Do not reset the jobName selection after deletion
        // Update jobList based on the selected client after deletion
        // this.updateJobList(this.ClientName);
      } else {
        console.error("Invalid index:", index);
      }
    }
  }
  
  
  
  
getOrderId(clientName: string, jobName: string): string {
  // Find the order in the orderList based on the clientName and jobName
  const order = this.orderList.find(order =>
    order.clientName.toLowerCase() === clientName.toLowerCase() &&
    order.jobName.toLowerCase() === jobName.toLowerCase()
  );
  // If the order is found, return its orderId, otherwise return an empty string
  return order ? order.orderId : '';
}


 
 

  get paginatedMaterialMixEntries(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.materialMixEntries.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  calculateRangeStart(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  calculateRangeEnd(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return Math.min(endIndex, this.materialMixEntries.length);
  }

  getNumberRangeMatMix(pages: number): number[] {
    return Array(pages).fill(0).map((x, i) => i + 1);
  }
  ceilValue(value: number): number {
    return Math.ceil(value);
  }

  //calculation of weightgae ,matrequired 
  // calculateMatRequired(index: number) {
  //   const entry = this.paginatedMaterialMixEntries[index];
  //   // Implement your formula here
  //   const matRequired = entry.matArray[0].rollNo * entry.matArray[0].return / 100; // Example formula
  //   // Update Mat_Required value
  //   entry.matArray[0].matRequired = matRequired;
  // }
}

